import { useState } from "react";
import styles from "./styles.module.css";
import { Grid, FormControlLabel, Typography } from "@mui/material";
import CustomTextField from "../utils/CustomFields/CustomTextField";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ButtonRed from "../utils/CustomFields/ButtonRed";
import ButtonGray from "../utils/CustomFields/ButtonGray";
import CustomCheckbox from "../utils/CustomFields/CustomCheckbox";
import { customerAmountFormat } from "helpers/NumberFormatHelper";

function EditVendor({ vendor, closeDialog, editVendorHandler, onClose }) {
  const [data, setData] = useState({
    ...vendor,
    is_active: vendor?.is_active ?? true,
  });

  const handleEditVendor = () => {
    if (!data.name || !data.mobile) {
      return;
    }
    editVendorHandler(data);
  };

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.closeIcoSection}>
          <CloseRoundedIcon onClick={onClose} className={styles.icon} />
        </div>
        <div className={styles.headerSection} style={{ paddingBottom: "15px" }}>
          <div>
            <h2>Edit Vendor</h2>
            <h4>Modify vendor details and keep information up to date.</h4>
          </div>
        </div>

        <Grid container spacing={2} className={styles.contentArea} mb={2}>
          <Grid item xs={12}>
            <CustomTextField label="Vendor Id" value={data?.id || ""} disabled placeholder="Vendor ID" />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              label="Vendor Name"
              placeholder="Enter name"
              value={data?.name || ""}
              onChange={(e) => setData({ ...data, name: e.target.value })}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextField
              label="Vendor Mobile"
              placeholder="Enter mobile"
              value={data?.mobile || ""}
              onChange={(e) => setData({ ...data, mobile: e.target.value })}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextField
              label="Vendor Code"
              placeholder="Enter code"
              value={data?.code || ""}
              onChange={(e) => setData({ ...data, code: e.target.value })}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextField
              label="Vendor Address"
              placeholder="Enter address"
              value={data?.address || ""}
              onChange={(e) => setData({ ...data, address: e.target.value })}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextField label="Balance" value={customerAmountFormat(data?.balance)} disabled />
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <CustomCheckbox
                  checked={data.is_active}
                  onChange={(e) => setData({ ...data, is_active: e.target.checked })}
                />
              }
              label={
                <Typography style={{ fontSize: "14px", fontWeight: 500, color: "#2b2b2b" }}>Active Vendor</Typography>
              }
            />
          </Grid>
        </Grid>

        <div className={styles.actionButtons}>
          <ButtonGray onClick={closeDialog}>Cancel</ButtonGray>
          <ButtonRed onClick={handleEditVendor}>Submit</ButtonRed>
        </div>
      </div>
    </div>
  );
}

export default EditVendor;
